export enum AnalysisMode {
  SingleRun = "SingleRun",
  ExperimentCollated = "ExperimentCollated",
}
